import React, { useState, useEffect } from 'react';

function CountdownTimer() {
  const eventDate = new Date('2026-04-25T09:00:00').getTime();

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const now = new Date().getTime();
    const diff = eventDate - now;

    if (diff <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((diff % (1000 * 60)) / 1000),
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="countdown-container">
      <h2 className="countdown-title">The Adventure Begins In...</h2>
      <div className="countdown-boxes">
        <div className="countdown-box">
          <div className="countdown-bubble">
            <span className="countdown-number">{String(timeLeft.days).padStart(2, '0')}</span>
          </div>
          <span className="countdown-label">Days</span>
        </div>
        <div className="countdown-separator">~</div>
        <div className="countdown-box">
          <div className="countdown-bubble">
            <span className="countdown-number">{String(timeLeft.hours).padStart(2, '0')}</span>
          </div>
          <span className="countdown-label">Hours</span>
        </div>
        <div className="countdown-separator">~</div>
        <div className="countdown-box">
          <div className="countdown-bubble">
            <span className="countdown-number">{String(timeLeft.minutes).padStart(2, '0')}</span>
          </div>
          <span className="countdown-label">Minutes</span>
        </div>
        <div className="countdown-separator">~</div>
        <div className="countdown-box">
          <div className="countdown-bubble">
            <span className="countdown-number">{String(timeLeft.seconds).padStart(2, '0')}</span>
          </div>
          <span className="countdown-label">Seconds</span>
        </div>
      </div>
      <p className="countdown-date">25-26 April 2026</p>
    </div>
  );
}

export default CountdownTimer;
